/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NpiResponseEnumerationType } from './NpiResponseEnumerationType';
import {
    NpiResponseEnumerationTypeFromJSON,
    NpiResponseEnumerationTypeFromJSONTyped,
    NpiResponseEnumerationTypeToJSON,
} from './NpiResponseEnumerationType';

/**
 * 
 * @export
 * @interface ValidatePalNpiResponse
 */
export interface ValidatePalNpiResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidatePalNpiResponse
     */
    found: boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidatePalNpiResponse
     */
    npi: string;
    /**
     * 
     * @type {NpiResponseEnumerationType}
     * @memberof ValidatePalNpiResponse
     */
    enumeration_type?: NpiResponseEnumerationType;
}

/**
 * Check if a given object implements the ValidatePalNpiResponse interface.
 */
export function instanceOfValidatePalNpiResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "npi" in value;

    return isInstance;
}

export function ValidatePalNpiResponseFromJSON(json: any): ValidatePalNpiResponse {
    return ValidatePalNpiResponseFromJSONTyped(json, false);
}

export function ValidatePalNpiResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatePalNpiResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'found': json['found'],
        'npi': json['npi'],
        'enumeration_type': !exists(json, 'enumeration_type') ? undefined : NpiResponseEnumerationTypeFromJSON(json['enumeration_type']),
    };
}

export function ValidatePalNpiResponseToJSON(value?: ValidatePalNpiResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'found': value.found,
        'npi': value.npi,
        'enumeration_type': NpiResponseEnumerationTypeToJSON(value.enumeration_type),
    };
}

